import axios from "./axios";

// Pliki platne (materialy kursowe, sprzedawane pliki sklepu) nie sa juz
// wydawane z /api/static - backend odcina te sciezki od statycznego
// montowania (middlewares/staticGuard.js), bo obchodzily bramki kontrolerow.
// Otwieramy je wiec przez uwierzytelniony endpoint API i blob URL.
//
// Zakladka musi powstac SYNCHRONICZNIE, przed pierwszym await: window.open
// wywolane po odpowiedzi sieciowej nie jest juz reakcja na klik i przegladarka
// blokuje je jako popup.
export async function openProtectedFile(url, filename) {
  const tab = window.open("", "_blank");
  let objectUrl = null;
  try {
    const response = await axios.get(url, { responseType: "blob" });
    // Interceptor 401 w axios.js nie odrzuca obietnicy, tylko konczy ja bez
    // wartosci (i wylogowuje), wiec brak odpowiedzi traktujemy jak blad.
    if (!response || !response.data) {
      throw new Error("Brak odpowiedzi z serwera");
    }
    const type =
      response.headers["content-type"] || "application/octet-stream";
    objectUrl = window.URL.createObjectURL(
      new Blob([response.data], { type })
    );
    if (tab) {
      tab.location.href = objectUrl;
    } else {
      // Popup zablokowany - zostaje pobranie pliku
      const link = document.createElement("a");
      link.href = objectUrl;
      link.setAttribute("download", filename || "plik");
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    // Zakladka dopiero wczytuje blob, wiec zwalniamy go z opoznieniem
    setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000);
    return true;
  } catch (error) {
    if (objectUrl) {
      window.URL.revokeObjectURL(objectUrl);
    }
    // Zamiast zamknac zakladke bez slowa: pusta karta to dla uzytkownika
    // wrazenie, ze klik nic nie zrobil.
    if (tab) {
      try {
        tab.document.title = "Brak dostępu do pliku";
        tab.document.body.innerText =
          "Nie udało się otworzyć pliku. Zaloguj się na konto, na którym " +
          "kupiłeś ten materiał, i spróbuj ponownie.";
      } catch (writeError) {
        tab.close();
      }
    }
    return false;
  }
}
